import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import MegaMenuComponent from './components/MegaMenuComponent'
import store from '../shared/store'

/**
 * Mega Menu
 *
 * @param megaMenu<Object> - window.drupalSettings.megaMenu
 */
const MegaMenu = () => {
  const containerID = document.querySelector('.block-adagiomegamenu')
  const root = ReactDOM.createRoot(containerID);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <MegaMenuComponent />
      </Provider>
    </StrictMode>
  )
}

export default MegaMenu
